import ApiConstants from "../constants/ApiConstants";
import http from "../http";

class BiometricAttendanceService {

    static getFormFieldConfig() {
        const url = ApiConstants.URL.BASE+ApiConstants.URL.BIOMETRIC_ATTENDANCE.GET_FIELD_CONFIG;
        return http.get(url);
    }

    static saveAttendanceDetails(body) {
        const url = ApiConstants.URL.BASE+ApiConstants.URL.BIOMETRIC_ATTENDANCE.SAVE_ATTENDANCE_DETAILS;
        return http.post(url,body);
    }

    static getBiometricDetails() {
        const url = ApiConstants.URL.BASE+ApiConstants.URL.BIOMETRIC_ATTENDANCE.GET_ATTENDANCE_DETAILS;
        return http.get(url);
    }

    static deleteBiometricDetails() {
        const url = ApiConstants.URL.BASE+ApiConstants.URL.BIOMETRIC_ATTENDANCE.DELETE_ATTENDANCE_DETAILS;
        return http.post(url);
    }

}

export default BiometricAttendanceService;